/* eslint-disable react-refresh/only-export-components */
import { CSSProperties, ElementType } from 'react'

import loadImg from '@/assets/images/load.gif'

import {
  ButtonChildProps,
  ButtonIconContainer,
  ButtonLoadingIcon,
  RootContainer,
  RootContainerProps,
  ButtonSpan,
} from './Button.styles'

export const Button = {
  Root: RootComponent,
  Icon: ButtonIcon,
  Text: ButtonText,
}

function RootComponent({
  $loading: loading = false,
  $disabledMessage,
  disabled,
  children,
  ...rest
}: RootContainerProps) {
  if (disabled && $disabledMessage) {
    return (
      <RootContainer $loading={loading} disabled={disabled} {...rest}>
        {loading && <ButtonLoadingIcon src={loadImg} alt="Carregando" />}
        <ButtonSpan>{$disabledMessage}</ButtonSpan>
      </RootContainer>
    )
  }

  return (
    <RootContainer $loading={loading} disabled={disabled} {...rest}>
      {!loading ? children : <ButtonLoadingIcon src={loadImg} alt={$disabledMessage || 'Carregando'} />}
    </RootContainer>
  )
}

interface ButtonIconProps extends ButtonChildProps {
  value: ElementType
  style?: CSSProperties
  size?: number
}

function ButtonIcon({ value: Icon, style, size = 16, ...rest }: ButtonIconProps) {
  return (
    <ButtonIconContainer {...rest}>
      <Icon size={size} style={style} />
    </ButtonIconContainer>
  )
}

interface ButtonTextProps {
  value: string
}

function ButtonText({ value }: ButtonTextProps) {
  return <ButtonSpan>{value}</ButtonSpan>
}
